export default __webpack_public_path__ + "static/media/photo--lg--wheel-5.041818ed.jpg";